import { EventEmitter } from 'events';
import $ from 'jquery';

import * as ContentStore from '../../stores/content-store';
import * as MenuStore from '../../stores/menu-store';
import * as LanguageStore from '../../stores/language-store';

export class MenuPanel extends EventEmitter {
    constructor() {
        super();
        this.isOpen = false;
        this.subMenuItems = [];
        this.panel = $('.menuPanel');
        this.subMenu = $('.menuPanel__submenu');
        this.closePanelButton = $('.menuPanel-close-btn');
        this.backButton = $('.menuPanel__back-btn');
        this.backButtonText = $('.menuPanel__back-btn__text');
        this.title = $('.menuPanel__title');

        this.initButtons();

        this._onMenuItemClick = this._onMenuItemClick.bind(this);
        this.updateContents();
    }

    initButtons() {
        this.panel.on('click touch', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this._openPanel();
        });

        this.closePanelButton.on('click touch', (event) => {
            event.stopPropagation();
            this._closePanel();
        });

        this.backButton.on('click touch', (event) => {
            event.stopPropagation();
            this._hideSubMenu();
            this._showMenuItems();
            this._hideBackButton();

        });
    }

    _openPanel() {
        const _this = this;

        this.isOpen = true;
        this.panel.removeClass('hide');

        $('.menuPanel__button--filter').each( function(){ // eslint-disable-line func-names
            $(this).click( (event) => {
                event.stopPropagation();
                _this._onMenuItemClick(this);
            })
        });
    }

    _closePanel() {
        this.isOpen = false;
        this.panel.addClass('hide');
        this._unbindMenuItemClick();
        this._hideSubMenu();
        this._showMenuItems();
        this._hideBackButton();
    }

    _onMenuItemClick(target) {
        if(this.isOpen) {
            const type = $(target).data('type');
            this.panel.addClass('expand');
            this._hideMenuItems();
            this._showSubMenu();
            this._getSubMenuData(type);
            this._showBackButton();
        }
    }

    updateContents() {
        const _this = this;
        const lang = LanguageStore.get();
        const title = MenuStore.get()[0];

        if(lang === 'cn') {
            $('.menuPanel__button--filter').addClass('chinese');
            this.subMenu.find('.list').addClass('chinese');
            this.title.addClass('chinese').html('探索');
            this.backButton.addClass('chinese');
            this.backButtonText.html('返回');

        } else {
            $('.menuPanel__button--filter').removeClass('chinese');
            this.subMenu.find('.list').removeClass('chinese');
            this.title.removeClass('chinese').html('explore');
            this.backButton.removeClass('chinese');
            this.backButtonText.html('back');
        }


        $('.menuPanel__button--filter').each( function() {
           const type = $(this).data('type');
           $(this).find('span').html(title[type + '_' + lang]);
        });

        $('.subMenu-item').each( function(index) {
            const header = _this.subMenuItems[index]['header_' + lang];
            $(this).find('span').html(header);
        })
    }

    _showSubMenu() {
        this.subMenu.css('display','block');
        setTimeout(()=>{
            this.subMenu.addClass('active');
        },100);
    }

    _hideSubMenu() {
        $('.menuPanel__submenu--mask').html('');
        this.subMenu.css('display','none');
        this.subMenu.removeClass('active');
    }

    _unbindMenuItemClick() {
        $('.menuPanel__button--filter').unbind('click');
    }

    _hideMenuItems() {
        const menuBtns = $('.menuPanel__button--filter');
        menuBtns.css('display', 'none');
    }

    _showMenuItems() {
        const menuBtns = $('.menuPanel__button--filter');
        menuBtns.css('display', 'block');
    }

    _getSubMenuData(type) {
        const contents = ContentStore.getExcludeLocation();
        this.subMenuItems = [];
        for(const contentType in contents) {
            if(type === contentType) {
                const items = contents[contentType];
                this.subMenuItems = items.map( (item) => {
                    return {
                        header_en: item.header_en,
                        header_cn: item.header_cn,
                        id: item.id
                    }
                });
                break;
            }
        }

        this._createSubMenuItems(type);
    }

    _createSubMenuItems(type) {
        const _this = this;
        const lang = LanguageStore.get();

        const subMenuMask = $('.menuPanel__submenu--mask');
        const items = this.subMenuItems.map( (item, i)=> {
            return `<div class="list subMenu-item menuPanel__button--${type}" data-content-id="${item.id}">` +
                `<div class="icon-container">` +
                    `<button class="icon icon-${type}"></button>` +
                `</div>` +
                `<span>${item['header_'+lang]}</span>` +
                `</div>`

        });

        subMenuMask.html(items.join(''));

        $('.subMenu-item').each( function() {
            $(this).click( () => {
                const id = $(this).data('content-id');
                _this.emit('onClickSubMenuItem', id);
                _this.slideOut();
            });
        })

        this.updateContents();
    }

    _showBackButton() {
        this.backButton.addClass('active');
        this.title.addClass('inactive');
    }

    _hideBackButton() {
        this.backButton.removeClass('active');
        this.title.removeClass('inactive');
    }

    _resetFilterButtons() {
        // const filterBtns = $('.menuPanel__button--filter');
        // filterBtns.removeClass('active').removeClass('inactive');
    }


    slideOut() {
        this.panel.removeClass('in').addClass('out');
        // if(this.panel.hasClass('open')) {
        //     setTimeout( () => {
        //         this._closePanel();
        //     }, 1000);
        //
        // }
    }

    slideIn() {
        this.panel.removeClass('out').addClass('in');
    }
}
